var map = {
	"./trade-01-th.svg": "dc3d",
	"./trade-01.svg": "194e",
	"./trade-02.svg": "b989",
	"./trade-03.svg": "8c43",
	"./trade-04.svg": "599c",
	"./trade-05.svg": "be7c",
	"./trade-06.svg": "5c0f",
	"./trade-07.svg": "b1df",
	"./trade-08.svg": "67a8",
	"./trade-09.svg": "ab22",
	"./trade-10.svg": "72a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e555";